<template>
  <div class="edit-video-box">
    <el-dialog
      :title="'AV图文编辑'"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form
        ref="form"
        :model="editParam"
        label-position="left"
        label-width="110px">
        <div class="form-flex-box">
          <el-form-item label="上传视频:">
            <!--视频分片上传-->
            <uploader
              :options="options"
              class="uploader-example"
              ref="uploader"
              @file-added="fileAdd"
              @file-success="onFileSuccess">
              <uploader-unsupport></uploader-unsupport>
              <uploader-drop>
                <uploader-btn :attrs="attrs">上传视频</uploader-btn>
              </uploader-drop>
              <uploader-list></uploader-list>
            </uploader>
          </el-form-item>
          <el-form-item
            label="封面上传:"
            prop="cover">
            <base-upload
              :cover="editParam.cover"
              :action="action"
              @successCallback="successCallback"
              :id="editParam.sourceID"
              :wSize="640"
              :hSize="360"
              :width="'213px'"
              :height="'120px'">
            </base-upload>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="资源URL:" prop="sourceURL">
            <el-input width="110px" v-model="editParam.sourceURL" size="small" disabled></el-input>
          </el-form-item>
          <el-form-item label="资源ID:" prop="sourceID">
            <el-input v-model="editParam.sourceID" size="small" disabled></el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="标题:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入标题内容"
              v-model="editParam.title">
            </el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="描述:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入描述内容"
              v-model="editParam.desc">
            </el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="影片信息:">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入描述影片信息"
              v-model="editParam.videoInfo">
            </el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="标签:" prop="tags">
            <tag-selector v-model="editParam.tags" :tagList="tagList"></tag-selector>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="价格:" prop="price">
            <el-input v-model.number="editParam.price" size="small" placeholder="请输入价格">
            </el-input>
          </el-form-item>
          <el-form-item label="期数:" prop="price">
            <el-input v-model.number="editParam.period" size="small" placeholder="请输入期数">
            </el-input>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="分成博主id:" prop="bloggerId">
            <el-input v-model.number="editParam.bloggerId" size="small" placeholder="请输入博主id">
            </el-input>
          </el-form-item>
          <el-form-item label="启/禁用:" prop="status">
            <el-select
              v-model.number="editParam.active"
              placeholder="请选择启/禁用状态"
              size="small">
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-flex-box">
          <el-form-item label="分成比例:" prop="taxLevel">
            <el-select size="small" v-model="editParam.taxLevel">
              <el-option
                v-for="item in taxLevels"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <br/>
            <span style="color:red;font-size:10px;">分成比例说明: 28分, 博主2成, 平台8成, 以此类推</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button
          type="primary"
          size="small"
          @click="editVideo()"
          :loading="flag">
          确 认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import local from '@/utils/localStroage.js'
import API from "@/api";
import TagSelector from "@/components/tagSelector";
export default {
  data() {
    return {
      trackId: '',
      dialogVisible: false,
      flag: false,
      isEdit: true,
      tagList: [],
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      editParam: {
        tags: [],
        id: "",
        cover: "",
        coverThumb: "",
        title: "",
        active: "",
        sourceID: "",
        sourceURL: "",
        desc: "",
        price: 0,
        period: 0,
        videoInfo: "",
        taxLevel: 0,
        bloggerId: 0
      },
      attrs: {
        accept: [
          '.mp4',
          '.qlv',
          '.qsv',
          '.ogg',
          '.flv',
          '.avi',
          '.wmv',
          '.rmvb'
        ] // 接受文件类型
      },
      taxLevels: [
        { value: 0, label: "不分成" },
        { value: 2, label: "28分" },
        { value: 3, label: "37分" },
        { value: 4, label: "46分" },
        { value: 5, label: "55分" },
      ]
    };
  },
  components: {
    TagSelector
  },
  computed: {
    options() {
      return {
        target: baseConfig.baseServerUrl + '/vid/uploadDotStream', // 上传地址
        //  target: baseConfig.baseServerUrl + "/vid/uploadDotJson", //上传地址
        testChunks: false, // 是否开启服务器分片校验
        method: 'application/json',
        headers: {
          // 额外请求头
          Authorization: local.get('userInfo')
            ? local.get('userInfo').token
            : ''
        },
        fileParameterName: 'upload', // 文件名参数，默认为file
        query: this.uploadQuery, // 额外参数
        singleFile: true, // 单文件上传
        chunkSize: 2048000, // 分片大小，默认1M
        simultaneousUploads: 6,
        // 把英文时间转成中文
        parseTimeRemaining: function(timeRemaining, parsedTimeRemaining) {
          return parsedTimeRemaining
            .replace(/\syears?/, '年')
            .replace(/\days?/, '天')
            .replace(/\shours?/, '小时')
            .replace(/\sminutes?/, '分钟')
            .replace(/\sseconds?/, '秒')
        }
      }
    }
  },
  methods: {
    getTagList() {
      const params = {
      }
      API.queryTagList(params)
        .then(res => {
          if(res.code === 200) {
            this.tagList = res.data.list
          }
        })
    },
    // 编辑
    editVideo() {
      if (this.editParam.tags.length>3){
         this.$message({
           message: "标签最多选三个",
           type: "error",
         });
        return
      }
      if (this.editParam.id == "" || this.editParam.id == null) {
        this.$message({
          message: "编辑数据id为空",
          type: "error",
        });
        return
      }
      if (this.editParam.price < 0) {
        this.$message({
          message: "价格不能为负",
          type: "error",
        });
        return
      }
      API.editAvComment(this.editParam)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "编辑成功！",
              type: "success",
            });
            this.$emit("handlerVideoList");
          } else {
            this.$message.error("编辑失败！");
          }
            this.flag = false;
            this.handleClose();
        })
        .catch(() => {
            this.flag = false;
            this.handleClose();
        });
    },
    // 标签封面上传成功回掉
    successCallback(res) {
      this.editParam.cover = res.data.coverImg;
      this.editParam.coverThumb = res.data.coverImg;
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.getTagList();
      this.dialogVisible = true;
      this.editParam.id = data.id;
      this.editParam.active = data.active;
      this.editParam.cover = data.cover;
      this.editParam.title = data.title;
      this.editParam.sourceID = data.sourceID;
      this.editParam.sourceURL = data.sourceURL;
      this.editParam.desc = data.desc;
      this.editParam.price = data.price;
      this.editParam.period = data.period;
      this.editParam.videoInfo = data.videoInfo;
      this.editParam.tags = data.tags ? data.tags : []
      this.editParam.taxLevel = data.taxLevel
      this.editParam.bloggerId = data.bloggerId
    },
    // 关闭回掉
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
    },
    // 视频上传成功时回调函数
    // eslint-disable-next-line no-unused-vars
    onFileSuccess(rootFile, file, response, chunk) {
      const res = JSON.parse(response)
      this.editParam.sourceID = res.data.sourceID
      this.editParam.sourceURL = res.data.sourceURL
      //通知文件服务器, 上传完成
      API.uploadSuccess({id: res.data.sourceID})
        .then((res) => {
          if (res.code !== 200) {
            this.$message.error("通知失败！");
          }
        })
        .catch(() => {
            this.$message.error("通知异常！");
        });
    },
    // 视频上传选中时
    fileAdd() {
      this.generateTaskId()
    },
    // 定义视频上传唯一标识符id
    generateTaskId() {
      const time = new Date().getTime()
      this.trackId = time
    },
    // 视频上传额外参数
    uploadQuery(file, chunk) {
      return {
        pos: chunk.offset,
        id: String(this.trackId)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 150px;
  }
  .form-flex-box {
    display: flex;
    .el-form-item {
      flex: 1;
    }
  }
}
</style>
